import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import { cn } from '../../../../../../helpers/classBuilders';
import { useClassHelper } from '../../../../../../hooks/useClassHelper';
import { componentName } from '../../constants';

interface Props
  extends PropsWithChildren,
    ButtonHTMLAttributes<HTMLButtonElement> {
  ghost?: boolean;
}

export const Button = ({ children, ghost, ...props }: Props) => {
  const c = useClassHelper(componentName);

  return (
    <button
      type="button"
      className={cn(
        c('__button', { '__button--ghost': ghost }),
        'overflow-x-hidden',
      )}
      {...props}
    >
      {children}
    </button>
  );
};
